import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import arrowDown from 'four-nets/icons/svg/icon_arrow-down.svg';
import defaultStyles from './select.scss';

export interface Props extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'style'> {
    beforeElement?: React.ReactNode;
    styles: typeof defaultStyles;
    touched?: boolean;
    errors?: React.ReactNode[];
    value?: any;
}

class Select extends React.Component<Props> {
    static defaultProps = {
        beforeElement: null,
        multiple: false,
    };

    random = Math.random();

    render() {
        const { beforeElement, touched, errors, styles, multiple, name, id, ...rest } = this.props;
        const showValidationErrors = errors && touched;

        const ID = id || name || `${name}-${this.random}-id`;

        return (
            <div tabIndex={0} className={classnames(styles.select, { [styles.invalid]: showValidationErrors })}>
                <label htmlFor={ID} className={styles.label}>
                    {name || ''}
                </label>
                <div className={classnames(styles.container)}>
                    <SVGIcon style={{ image: styles.icon }} src={arrowDown} />
                    {beforeElement}
                    <select id={ID} name={name} className={classnames(styles.element)} multiple={multiple} {...rest} />
                </div>
                {showValidationErrors &&
                    errors!.map((error, index) => {
                        return (
                            <p key={index.toString()} className={styles.error}>
                                {error}
                            </p>
                        );
                    })}
            </div>
        );
    }
}

export default Styled(defaultStyles)(Select);
